import { render, staticRenderFns } from "./ChatBoxMessageList.vue?vue&type=template&id=2abb208d&scoped=true&"
import script from "./ChatBoxMessageList.vue?vue&type=script&lang=js&"
export * from "./ChatBoxMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxMessageList.vue?vue&type=style&index=0&id=2abb208d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb208d",
  null
  
)

export default component.exports